import React from 'react'

export const LogisticHintText = () => (
  <>
    КОМПАНИЯ
    <ul>
      <li>
        Паспорт руководителя фирмы/ИП – страницы лицевая и с постоянной регистрацией (если отказываются, то не настаивать, но предупредить что может
        не пройти СБ)
      </li>
    </ul>
  </>
)

export default LogisticHintText
